export enum WellbeingRoutesV1 {
    ROUTE_WELLBEING = "/mis-beneficios-v1",
    // discounts
    ROUTE_WELLBEING_DISCOUNTS = "/mis-beneficios-v1/descuentos",
    ROUTE_WELLBEING_DISCOUNTS_MULTIVENTAJASPLUS = "/mis-beneficios-v1/descuentos/vida/multiventajas-plus",
    ROUTE_WELLBEING_DISCOUNTS_ETNA = "/mis-beneficios-v1/descuentos/autos/etna",
    ROUTE_WELLBEING_DISCOUNTS_CLEANING = "/mis-beneficios-v1/descuentos/autos/limpieza",
    ROUTE_WELLBEING_DISCOUNTS_MAINTENANCE = "/mis-beneficios-v1/descuentos/autos/mantenimiento",
    ROUTE_WELLBEING_DISCOUNTS_ACCESORIES = "/mis-beneficios-v1/descuentos/autos/accesorios",
    ROUTE_WELLBEING_DISCOUNTS_TECHNICAL_INSPECTION = "/mis-beneficios-v1/descuentos/autos/revision-tecnica",
    // services
    ROUTE_WELLBEING_SERVICES = "/mis-beneficios-v1/servicios",
    ROUTE_WELLBEING_SERVICES_HEALTH_AT_HOME = "/mis-beneficios-v1/servicios/salud/salud-en-casa",
    // rewards
    ROUTE_WELLBEING_REWARDS = "/mis-beneficios-v1/recompensas",
    ROUTE_WELLBEING_SCRATCH_GAME = "/mis-beneficios-v1/recompensas/raspa-y-gana/:id",
}
